<template>
    <div class="ProcessSubview">
        <QCard
            bordered
            class="ProcessSubviewCard"
        >
            <QCardSection class="q-pa-none">
                <Overview
                    :processId="processId"
                    :infoTotal="infoTotal"
                    :infoFiltered="infoFiltered"
                    :forcedTab="forcedTab"
                />
            </QCardSection>
        </QCard>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import Overview from '../Booster/Overview.vue'

export default {
    name: 'BoosterSubview',
    components: { Overview },
    props: {
        processId: VueTypes.any,
        infoTotal: VueTypes.object,
        infoFiltered: VueTypes.object,
        forcedTab: VueTypes.string,
    },
}
</script>

<style scoped lang="scss">
.ProcessSubview {
    height: 100%;
}

.ProcessSubviewCard {
    height: 100%;
}
</style>
